import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';

@Injectable()

export class GlobalService {
    env = environment;
    constructor(){}

    /**
     * check if a filter is active from admin setting
     * @param {string} tab
     * @param filter_name
     */
    isFilterActive(tab: string, filter_name){
        return this.env.filters[tab].indexOf(filter_name);
    }

    /**
     * get filter name value
     * @param {string} filter_name
     * @param filter_value
     * @returns {string}
     */
    getFilterName(filter_name: string, filter_value: any){
        let name = '';
        switch(filter_name){
            case 'platform':
                name = this.env.platforms[filter_value].name;
                break;
            case 'status':
                name = this.env.status[filter_value].name;
                break;
            default:
                name = 'none';
        }

        return name;
    }

    /**
     * format status object properties to a human friendly format
     * @param {string} word
     * @returns {string}
     */
    formatStatus(word: string){
        const string = word.substr(3);

        return string.charAt(0).toUpperCase() + string.slice(1);
    }

    /**
     * clone an object
     * useful when cloning needed to keep a copy of an old version of an object
     * @param {object} old_obj
     * @returns {{}}
     */
    cloneObject(old_obj: object){
        let new_obj = {};
        for(let key in old_obj){
            new_obj[key] = old_obj[key]
        }

        return new_obj
    }

    /**
     * convert an object to an array
     * @param {object} old_obj
     * @returns {any[]}
     */
    objToArray(old_obj: object){
        let new_arr = [];
        for(let key in old_obj){
            let new_obj = {};
            new_obj[key] = old_obj[key]
            new_arr.push(new_obj)
        }

        return new_arr;
    }
}


// WEBPACK FOOTER //
// /Users/moe.dchater/personal/firebase-projects/hosting/src/app/services/global.service.ts